import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './mark.routes';
import addHtml from './modal/add.html';

export class MarksController {
    $http;
    socket;
    awesomeThings = [];
    marks = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('mark');
        });
    }

    $onInit() {
        if (this.$cookies.get('token')) {

            this.$http.get('/api/marks/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;
                        this.marks = response.data.data;
                        console.log(this.marks);

                        this.socket.syncUpdates('marks', this.marks);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    search() {

        if (this.$cookies.get('token')) {

            this.$http.get('/api/marks/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': this.currentPage - 1,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.marks = response.data.data;
                        console.log(this.marks);

                        this.socket.syncUpdates('marks', this.marks);
                    }
                });
        } else {
            this.$location.path('main')
        }


    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    mark(mark, index) {
        this.$http.delete(`/api/marks/${mark.mark_id}`).then(response => {
            if (response.status === 204) {
                this.marks.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    // addSurvey() {
    //   const surveys = this.surveys;
    //   this.$uibModal.open({
    //     template: addHtml,
    //     size: 'lg',
    //     /*@ngInject*/
    //     controller: function($scope, $http, $uibModalInstance) {
    //       $scope.vm = {};
    //       $scope.save = function(myForm) {
    //         if (myForm.$valid === false) {
    //           return false;
    //         } else {
    //           $http.post('/api/surveys', $scope.vm).then((response) => {
    //             $uibModalInstance.close(response.data);
    //           }, (error) => {
    //             console.log(error);
    //           });
    //         }
    //       };
    //       $scope.cancel = function() {
    //         $uibModalInstance.close();
    //       };
    //     }
    //   })
    //     .result.then(function(ret) {
    //     if (ret) {
    //       surveys.push(ret);
    //     }
    //   }, function () {
    //   });
    // }

}

export default angular.module('tttApp.mark', [uiRouter])
    .config(routing)
    .component('mark', {
        template: require('./mark.html'),
        controller: MarksController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/mark/mark.component.js